<div
  data-automation-id="ap-saves-search-sidebar"
  class="ap-saves-search-sidebar"
  [@slideInOut]="show ? 'in' : 'out'">
  <div class="d-flex justify-content-between mb-6">
    <button
      class="close-btn p-0 h-auto"
      (click)="onDismissActiveModal()"
      [attr.aria-label]="'closeItemsDrawer' | translate"
      data-automation-id="close-drawer-btn">
      <span class="icon-close"></span>
    </button>

    <div class="d-flex">
      <h4 class="modal-title font-weight-bold"
          id="drawer-items-title"
          data-automation-id="drawer-items-title">
        Saved Searches
      </h4>
    </div>

  </div>
</div>
